export default "__VITE_ASSET__CCCmZ$ir__"